import type { Component } from 'vue'
import {
  BassIcon,
  DrumsIcon,
  GuitarIcon,
  MusicNoteIcon,
  PianoIcon,
  StringsIcon,
  SynthesizerIcon,
  VoiceAndNoiseIcon,
  WindIcon,
} from '@dacr/icons'

const STEM_ICONS: Record<string, Component> = {
  vocals: VoiceAndNoiseIcon,
  vocal: VoiceAndNoiseIcon,
  speech: VoiceAndNoiseIcon,
  drums: DrumsIcon,
  percussion: DrumsIcon,
  bass: BassIcon,
  guitar: GuitarIcon,
  synth: SynthesizerIcon,
  synthesizer: SynthesizerIcon,
  piano: PianoIcon,
  keys: PianoIcon,
  keyboard: PianoIcon,
  strings: StringsIcon,
  wind: WindIcon,
  instrumental: MusicNoteIcon,
}

export const stemIcon = (stemName: string): Component =>
  STEM_ICONS[stemName.toLowerCase()] ?? MusicNoteIcon
